// extracted by mini-css-extract-plugin
export default {"landingPageAccordionItem":"N3-z"};